import { ShoppingCart, TIPO_DOCUMENTAL, IElasticReturnClass, InventoryIdenty, UnidadDocumentalSimple, Estados } from '../inventories';
import { Bloqueo, Cambio } from './common';

/**
 * Clases de modelo para representación de un AZ. Es usado en el servicio encargado
 */
export class AzDetail extends UnidadDocumentalSimple implements IElasticReturnClass, InventoryIdenty {
    idAz: string;
    idContenedor: number;
    numContenedor: number;
    idSecLevel: number;
    nombreSerie: string;
    idSerie: number;
    historialCambios: Cambio[];
    descripcion: string;
    estado: Estados;
    fechaCreacion: string;
    bloqueos: Bloqueo[];
    id: string;
    shoppingCart: ShoppingCart;
    tipoDocumental: TIPO_DOCUMENTAL;
    clienteId: number;
    inventoryLevel: number;


    constructor() { super(); }

    static toModel(json: string) {
        const data = JSON.parse(json);
        const toReturn = new AzDetail();

        toReturn.idAz = data.ID_AZ;
        toReturn.idContenedor = data.ID_CONTENEDOR;
        toReturn.numContenedor = data.NUM_CONTENEDOR;
        toReturn.idSecLevel = data.ID_SEC_LEVEL;
        toReturn.nombreSerie = data.NOMBRE_SERIE;
        toReturn.idSerie = data.ID_SERIE;
        if (data.HISTORIAL_CAMBIOS) {
            toReturn.historialCambios = data.HISTORIAL_CAMBIOS.map(cambio => Cambio.toModel(JSON.stringify(cambio)));
        }
        toReturn.descripcion = data.DESCRIPCION_AZ;
        if (data.ESTADO) {
            toReturn.estado = Estados.toModel(JSON.stringify(data.ESTADO));
        }
        if (data.FECHA_CREACION) {
            toReturn.fechaCreacion = data.FECHA_CREACION;
        }
        if (data.BLOQUEOS) {
            toReturn.bloqueos = data.BLOQUEOS.map(bloqueo => Bloqueo.toModel(JSON.stringify(bloqueo)));
        }
        toReturn.id = data.Id;
        toReturn.tipoDocumental = TIPO_DOCUMENTAL.az;
        toReturn.clienteId = data.ID_CLIENTE;
        toReturn.inventoryLevel = data.NIVEL_INVENTARIO;

        return toReturn;
    }
}

